import { createSlice } from "@reduxjs/toolkit";
import { ApiCallState, ApiCallStatus, Resource } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { urlResourceCallAsyncThunk } from "@myRedux/appAsyncThunkUtilities";

export interface ApiResource extends Resource {
}

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiCallState<ApiResource>;

export const getApiRootAsync = urlResourceCallAsyncThunk<ApiResource>('api/getApiRoot', '');

export const apiRootSlice = createSlice({
  name: 'api',
  initialState: initialState,
  reducers: {
    apiConnectionFailure(state, action) {
      state.status = ApiCallStatus.Failed;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApiRootAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(getApiRootAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = {
          links: action.payload.links
        };
      })
      .addCase(getApiRootAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
      })
  },
});

export const selectApiRoot = (state: RootState) => state.api.api;

const { actions, reducer } = apiRootSlice;
export const { apiConnectionFailure } = actions;
export default reducer;